import React from 'react';
import { useNavigation } from '@react-navigation/native';
import { useShallow } from 'zustand/react/shallow';
import { MercadoPagoQrPaymentModal } from '../../../mercadopago/components/MercadoPagoQrPaymentModal';
import { formatSaleShortRefSuffix } from '../../../sales/public-api';
import { usePosCheckoutStore } from '../../store/usePosCheckoutStore';
import { usePosMpQrActions } from '../../screens/hooks/usePosMpQrActions';
import { usePosStore } from '../../store/usePosStore';

export type PosMpQrModalContainerProps = {
  currentBranchId: string | null | undefined;
  userId: string | null | undefined;
  mercadopagoQrMethodAllowed: boolean;
  clearPersistenceAfterSale: () => void | Promise<void>;
  clearPendingSaleId: () => void;
  onMpQrApproved?: () => void;
};

export const PosMpQrModalContainer = ({
  currentBranchId,
  userId,
  mercadopagoQrMethodAllowed,
  clearPersistenceAfterSale,
  clearPendingSaleId,
  onMpQrApproved,
}: PosMpQrModalContainerProps) => {
  const navigation = useNavigation<any>();
  const clearCart = usePosStore((s) => s.clearCart);

  const { showQrModal, lastMpQrSaleId } = usePosCheckoutStore(
    useShallow((s) => ({
      showQrModal: s.showQrModal,
      lastMpQrSaleId: s.lastMpQrSaleId,
    })),
  );

  const resetCheckout = usePosCheckoutStore((s) => s.resetCheckout);
  const closeQrModal = usePosCheckoutStore((s) => s.closeQrModal);
  const setCheckoutVisible = usePosCheckoutStore((s) => s.setCheckoutVisible);

  const {
    mpQrSession,
    finalizeMpQrPosSession,
    handleConfigureMercadoPagoFromQr,
    handleChangePaymentMethodFromQr,
    handleOpenMpQrSaleInVentas,
    handleVoidMpQrSale,
  } = usePosMpQrActions({
    navigation,
    currentBranchId,
    lastMpQrSaleId,
    userId,
    clearCart,
    resetCheckout,
    closeQrModal,
    setCheckoutVisible,
    clearPersistenceAfterSale,
    clearPendingSaleId,
    onMpQrApproved,
  });

  return (
    <MercadoPagoQrPaymentModal
      visible={showQrModal}
      phase={mpQrSession.phase}
      loading={mpQrSession.loading}
      error={mpQrSession.error}
      qrData={mpQrSession.qrData}
      qrUrl={mpQrSession.qrUrl}
      amount={mpQrSession.amount}
      saleRef={lastMpQrSaleId ? formatSaleShortRefSuffix(lastMpQrSaleId) : null}
      expiresAt={mpQrSession.expiresAt}
      countdownSeconds={mpQrSession.countdownSeconds}
      fiscalInvoiceLabel={mpQrSession.fiscalInvoiceLabel}
      autoCloseProgress={mpQrSession.autoCloseProgress}
      lastMpQrSaleId={lastMpQrSaleId}
      onClose={finalizeMpQrPosSession}
      onRegenerate={mpQrSession.regenerateQr}
      onOpenSale={lastMpQrSaleId ? handleOpenMpQrSaleInVentas : undefined}
      onVoidSale={lastMpQrSaleId ? handleVoidMpQrSale : undefined}
      onChangePaymentMethod={handleChangePaymentMethodFromQr}
      onConfigureMercadoPago={
        mercadopagoQrMethodAllowed ? handleConfigureMercadoPagoFromQr : undefined
      }
    />
  );
};
